export const en = {
  accountPreferences: 'Account Preferences',
  helpdesk: 'Help Desk',
  logout: 'Logout',
  resources: 'Resources',
}

export const es = en
